export default "__VITE_ASSET__CdHHB4Pk__"